import React from 'react';
import '../../Hero.css';

function WorkDescription() {
  return (
    <div className="projects-description">
      <h1>
        My <span className="highlight">Professional Experience</span>
      </h1>
      <p className="page-subtitle">
        Production roles: AI hiring assessments at WOOOLY and B2B field software at Dataforma.
      </p>
    </div>
  );
}

export default WorkDescription;
